// load production dependencies
import './index';
